import styled from 'styled-components';

export const Container = styled.div`
  height: fit-content;
  min-height: 65vh;

  padding: 5rem 15rem;

  background-color: ${({ theme }) => theme.colors.gray0};

  @media (max-width: 1366px) {
    width: 100%;
    padding: 4rem 7.5rem;
  }

  @media (max-width: 1200px) {
    padding: 4rem 5rem;
  }

  @media (max-width: 768px) {
    padding: 4rem 3rem;
  }

  @media (max-width: 500px) {
    padding: 3rem 1.5rem;
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  gap: 10rem;

  > div {
    width: 50%;
  }

  @media (max-width: 1366px) {
    gap: 6rem;
  }

  @media (max-width: 1100px) {
    gap: 4rem;
  }

  @media (max-width: 1000px) {
    flex-direction: column;
    align-items: center;
    gap: 0;

    > div {
      width: 70%;
    }
  }

  @media (max-width: 768px) {
    > div {
      width: 90%;
    }
  }

  @media (max-width: 600px) {
    > div {
      width: 100%;
    }
  }
`;

export const LeftContent = styled.div`
  height: fit-content;

  h2 {
    width: 100%;

    font-size: 1.75rem;
    font-weight: 600;
    line-height: 150%;

    color: ${({ theme }) => theme.colors.gray7};

    margin-bottom: 1.5rem;
  }

  p {
    width: 80%;

    font-size: 1rem;
    font-weight: 400;
    line-height: 150%;

    color: ${({ theme }) => theme.colors.gray5};
  }

  a {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    gap: 1rem;

    width: fit-content;
    height: fit-content;

    padding: 1rem 2rem;

    background: ${({ theme }) => `${theme.colors.green4}29`};
    border-radius: 8px;

    color: ${({ theme }) => theme.colors.green4};

    font-size: 1.125rem;
    font-weight: 600;
    line-height: 1.6875rem;

    margin-top: 2.5rem;
    margin-bottom: 2.5rem;

    svg {
      width: 2rem;
      height: 2rem;
    }

    &:hover {
      background: ${({ theme }) => `${theme.colors.green4}40`};
    }
  }

  @media (max-width: 1000px) {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
  }
`;
